<script setup>
import { ref } from 'vue';
import { Link , usePage } from '@inertiajs/vue3';
import { formatDateBlog } from '@/Services/dateUtils';

const props = defineProps({
    web_site: Object,
    blog: Object,
    preview: Boolean
});

const page = usePage();
const clinicUuid = page.props?.clinicUuid;

const color = ref(props.web_site.color)

// Função para remover tags HTML
function stripHtmlTags(content) {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.textContent || div.innerText || '';
}

</script>
<template>

   <Link class="group block w-full overflow-hidden rounded-xl bg-white !max-w-[350px] transition hover:-translate-y-1 hover:shadow-lg" :href="route('blog.post.detail', { clinic: clinicUuid, user: web_site.page_url, id: blog.id })">
        <div class="aspect-[16/9] w-full"
            :style="{ backgroundImage: `url('${blog?.banner_path_url}')`, backgroundSize: 'cover', backgroundPosition: 'center' }">
        </div>
        <div class="flex min-h-48 flex-col px-3 py-4">
            <h3 class="text-base font-semibold leading-snug text-[#3f444a] transition-colors group-hover:text-[var(--website-color)]"
                :style="{ '--website-color': color }">
                {{ blog.title }}
            </h3>
            <p class="mt-2 text-xs font-medium text-[#5c6873]">por {{ web_site.text?.name }}</p>
            <span class="mt-0.5 text-xs text-[#5c6873]">{{ formatDateBlog(blog.date) }}</span>
            <p class="mt-3 text-xs leading-relaxed text-[#5c6873]">
                {{ stripHtmlTags(blog.content).length > 100 ? stripHtmlTags(blog.content).substring(0, 100) +
                    '...' : stripHtmlTags(blog.content) }}
            </p>
            <span v-if="preview" class="mt-10">
                <span v-if="blog.status == 'published'" class="bg-green-500 px-2 p-y-1 text-white rounded text-md">{{ $t('published') }}</span>
                <span v-if="blog.status == 'preview'" class="bg-yellow-500 px-2 p-y-1 text-white rounded text-md">{{ $t('preview') }}</span>
                <span v-if="blog.status == 'draft'" class="bg-red-500 px-2 p-y-1 text-white rounded text-md">{{ $t('draft') }}</span>
            </span>
        </div>
    </Link>

</template>
